// O mic-recorder-to-mp3 só tem start/stop. Para pausar e continuar a MESMA
// gravação (como no WhatsApp), o codificador MP3 segue aberto e o som do
// microfone apenas deixa de ser entregue a ele enquanto estiver pausado: o
// trecho gravado depois de "continuar" entra no mesmo arquivo.

// Mesmo intervalo que a biblioteca descarta no início da gravação, para não
// gravar o clique do mouse no botão de continuar.
const RESUME_GUARD_MS = 300;

// Chamar depois de cada Mp3Recorder.start(): cada start cria um processor novo.
export const enableRecorderPause = recorder => {
  const processor = recorder?.processor;
  recorder.paused = false;
  recorder.resumeGuardUntil = 0;
  if (!processor || processor.pausableWrapped) return;

  const encode = processor.onaudioprocess;
  processor.onaudioprocess = event => {
    if (recorder.paused) return;
    if (Date.now() < recorder.resumeGuardUntil) return;
    if (encode) encode.call(processor, event);
  };
  processor.pausableWrapped = true;
};

export const pauseRecorder = recorder => {
  recorder.paused = true;
};

export const resumeRecorder = recorder => {
  recorder.resumeGuardUntil = Date.now() + RESUME_GUARD_MS;
  recorder.paused = false;
};
